import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";


export const slotService = {
  fetchTimeSlots,
  createTimeSlot,
  deleteTimeSlot,
  fetchCounsellorList,
  fetchPublicCounsellorList,
  fetchMyCounsellor
};

function fetchTimeSlots(counsellor_id) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
  };
  return fetch(`${API_ROOT_URL}/slots/?q=${counsellor_id}`, requestOptions).then(response =>
    response.json()
  );
}

function createTimeSlot(slotDetails) {
  const token = JSON.parse(localStorage.getItem("token"));
  const user_id = JSON.parse(localStorage.getItem("user")).counsellor_id;

  var json = "" + JSON.stringify(slotDetails) + "";
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(slotDetails)
  };
  return fetch(`${API_ROOT_URL}/slots/`, requestOptions).then(
    handleResponse => {
      return handleResponse;
    }
  );
}

function deleteTimeSlot(slot_id) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return fetch(`${API_ROOT_URL}/slots/${slot_id}/`, requestOptions).then(
    handleResponse => {
      return handleResponse;
    }
  );
}

function fetchCounsellorList(language) {
  const project_id = localStorage.getItem("project_id")
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return fetch(
    `${API_ROOT_URL}/counsellors/?q=${project_id}${language ? '&language='+language : ''}`,
    requestOptions
  ).then(response => response.json());
}

function fetchPublicCounsellorList() {
  const project_id = localStorage.getItem("project_id")
  const requestOptions = {
    method: "GET"
  };
  return fetch(
    `${API_ROOT_URL}/counsellors/counsellor-public/?q=${project_id}`,
    requestOptions
  ).then(response => response.json());
}

function fetchMyCounsellor() {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return fetch(
    `${API_ROOT_URL}/counsellors/my_counsellor/`,
    requestOptions
  ).then(response => handleResponse(response))
  .then(data => {
    return data;
  });
}


// WEBPACK FOOTER //
// ./src/services/slot.service.js